<nav id="sidebar" [ngClass]="{'active': sidebarStatus === true}">
  <div class="sidebar-header animated bounce fadeIn">
    <div class="row">
      <div class="col-4 center line-height-100 pr0">
        <img *ngIf="!imageAdministration" [src]="logoCommunity" class="community-image br-circle" alt="comunidad">
        <img *ngIf="imageAdministration" [src]="imageAdministration" class="community-image br-circle" alt="comunidad">
      </div>
      <div class="col-8 text-left pt25">
        <label class="font-normal community-secondary">{{administration}}</label>
        <label class="font-normal community-secondary">{{ administrationIdentifier }}</label>
      </div>
    </div>
  </div>

  <ul class="components m0 mt10 animated bounce fadeIn">
    <li *ngIf="validPermission('community.list')">
      <a routerLinkActive="active" id="/communities" [routerLink]="['/communities']"
        (click)="changeRoute('/communities');">
        <label [ngClass]="urlActive === '/communities' ? 'txt-secondary' : '' ">
          <i class="fal fa-archive mr10 svg-width"></i>
        </label>
        <span class="txt-item">{{'CONFORMATION_OF_THE_COMMUNITY.COMMUNITIES.GENERAL.PLURAL' | translate}}</span>
      </a>
    </li>
    <!-- Configuración de Usuarios -->
    <li *ngIf="validPermission('users-config.module')">
      <a data-toggle="collapse" data-target="#usersconfig" aria-expanded="false" href="#">
        <label
          [ngClass]="urlActive === '/users-admin' || urlActive === '/roles-admin' || urlActive === '/permissions-admin' ? 'txt-secondary' : '' ">
          <i class="fal fa-users mr10 svg-width"></i>
        </label>
        <span class="txt-item">{{'USERS.GENERAL.CONFIG' | translate}}</span>
      </a>
      <ul class="collapse" id="usersconfig">
        <li *ngIf="validPermission('users-config.users-admin')">
          <div [ngClass]="{'circle': urlActive !== '/users-admin','circle-active': urlActive === '/users-admin'}"
            class="ml45"></div>
          <a class="pl60" routerLinkActive="active" id="/users-admin" [routerLink]="['/users-admin']"
            (click)="changeRoute('/users-admin');">
            <span class="txt-item">{{'USERS.GENERAL.PLURAL' | translate}}</span>
          </a>
        </li>
        <li *ngIf="validPermission('users-config.roles-admin')">
          <div [ngClass]="{'circle': urlActive !== '/roles-admin','circle-active': urlActive === '/roles-admin'}"
            class="ml45"></div>
          <a class="pl60" routerLinkActive="active" id="/roles-admin" [routerLink]="['/roles-admin']"
            (click)="changeRoute('/roles-admin');">
            <span class="txt-item">{{'ROLE.GENERAL.PLURAL' | translate}}</span>
          </a>
        </li>
        <li *ngIf="validPermission('users-config.permissions-admin')">
          <div
            [ngClass]="{'circle': urlActive !== '/permissions-admin','circle-active': urlActive === '/permissions-admin'}"
            class="ml45"></div>
          <a class="pl60" routerLinkActive="active" id="/permissions-admin" [routerLink]="['/permissions-admin']"
            (click)="changeRoute('/permissions-admin');">
            <span class="txt-item">{{'PERMISSION.GENERAL.PLURAL' | translate}}</span>
          </a>
        </li>
      </ul>
    </li>
    <!-- Configuración de Administración -->
    <!-- <li *ngIf="validPermission('users-config.module')"> -->
    <li *ngIf="validPermission('administration.config') || validPermission('contact.assign-app') || validPermission('contact.add')">

      <a data-toggle="collapse" data-target="#adminconfig" aria-expanded="false" href="#">
        <label
          [ngClass]="urlActive === '/administration-setup'
          || urlActive === '/administration-associate'
          || urlActive === '/administration-contact' ? 'txt-secondary' : '' ">
          <i class="fal fa-address-card mr10 svg-width"></i>
        </label>
        <span class="txt-item">{{'ADMINISTRATION.CONFIG.MODULE.MENU_ADMINISTRATION_PRINCIPAL' | translate}}</span>

      </a>

      <ul class="collapse" id="adminconfig">
        <li *ngIf="validPermission('administration.config')">
          <div [ngClass]="{'circle': urlActive !== '/administration-setup','circle-active': urlActive === '/administration-setup'}"
            class="ml45"></div>
          <a class="pl60" routerLinkActive="active" [routerLink]="['/administration-setup']"
            (click)="changeRoute('/administration-setup');">
            <span class="txt-item">{{'ADMINISTRATION.CONFIG.MODULE.MENU_ADMINISTRATION' | translate}}</span>
          </a>
        </li>
        <li *ngIf="validPermission('contact.assign')">
          <div [ngClass]="{'circle': urlActive !== '/administration-associate','circle-active': urlActive === '/administration-associate'}"
            class="ml45"></div>
          <a class="pl60" routerLinkActive="active" [routerLink]="['/administration-associate']"
            (click)="changeRoute('/administration-associate');">
            <span class="txt-item">{{'ADMINISTRATION.CONFIG.MODULE.ASSOCIATE_CONTACT' | translate}}</span>
          </a>
        </li>
        <li *ngIf="validPermission('contact.add')">
          <div [ngClass]="{'circle': urlActive !== '/administration-contact','circle-active': urlActive === '/administration-contact'}"
            class="ml45"></div>
          <a class="pl60" routerLinkActive="active" [routerLink]="['/administration-contact']"
            (click)="changeRoute('/administration-contact');">
            <span class="txt-item">{{'ADMINISTRATION.CONFIG.MODULE.CREATE_CONTACT' | translate}}</span>
          </a>
        </li>
      </ul>

    </li>
  </ul>
  <div class="sidebar-footer animated bounce fadeIn">
  </div>
</nav>



// WEBPACK FOOTER //
// ./src/app/layout/sidebar-community/sidebar-community.component.html